import {BaseEvent} from "sharedFeatures/directives/events/base-event";

export class ListDropEvent implements BaseEvent<Event>{


    constructor(public event: Event, public dragData: any, public targetItem: Element, public position: string) {


    }



}